import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';
import { ResetPasswordForm } from '@/screens/reset-password/components/ResetPasswordForm';

// Main Reset Password Screen
function ResetPasswordScreen() {
  const { t } = useTranslation('resetPassword');
  useTransactionLocale();

  useEffect(() => {
    trackPageView('change/password');
  }, []);

  const title = t('resetPasswordForm.title');

  document.title = t('pageTitle');

  return (
    <BaseWrapper title={title}>
      <ResetPasswordForm />
    </BaseWrapper>
  );
}

export default ResetPasswordScreen;
